import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource, MatTableDataSourcePageEvent } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerActionComponent } from 'src/app/shared/partner-action/partner-action.component';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'fury-review-url-list',
  templateUrl: './review-url-list.component.html',
  styleUrls: ['./review-url-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class ReviewUrlListComponent implements OnInit {
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    { name: 'Type', property: 'type', visible: true },
    {
      name: 'Percentage',
      property: 'percentage',
      visible: true,
    },
    { name: 'Ratio', property: 'ratio', visible: true },
    {name: 'Active', property: 'isActive', visible: true,},
    {name: 'Url', property: 'url', visible: true, isModelProperty: true},
    { name: 'Actions', property: 'actions', visible: true },
    
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  orderType:string = 'DESC'
  orderBy:string = 'type';
  arrowChanges:any = {
    type:'DESC',
    url:'DESC',
    percentage:'DESC'
  }
  searchBy: string = 'type';
  searchType: string = 'contains';
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });
  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService
  ) {
    this.filterValue = 'Review Urls';
    this.router.onSameUrlNavigation = 'reload';

    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.orderBy = res.orderBy ? res?.orderBy : 'type';
      this.orderType = res.orderType ? res.orderType : 'DESC';
      this.pageIndex = res.page ? Number(res.page) - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      if(this.orderType === "DESC" && this.orderBy === 'type'){
        this.arrowChanges.type = 'DESC';
      } else if(this.orderType === "ASC" && this.orderBy === 'type'){
        this.arrowChanges.type = 'ASC';
      } else if(this.orderType === "DESC" && this.orderBy === 'percentage'){
        this.arrowChanges.percentage = 'DESC';
      } else if(this.orderType === "ASC" && this.orderBy === 'percentage'){
        this.arrowChanges.percentage = 'ASC';
      } else if(this.orderType === "DESC" && this.orderBy === 'url'){
        this.arrowChanges.url = 'DESC';
      } else if(this.orderType === "ASC" && this.orderBy === 'url'){
        this.arrowChanges.url = 'ASC';
      }
      this.searchBy = res.searchBy ? res.searchBy : 'type';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });     
      this.getReviewUrlList();
    });
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void {
  }

  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/reputation/review-url?page=${this.pageIndex + 1
      }${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&orderType=${this.orderType}&orderBy=${this.orderBy}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
    this.getReviewUrlList();
  }
  orderEvent(orderBy:string){
    this.orderBy = orderBy;   
    if(this.orderType === 'DESC'){
      this.orderType = 'ASC';
    } else {
      this.orderType = 'DESC';
    }
    this.router.navigateByUrl(
      `/reputation/review-url?page=${this.pageIndex + 1
      }${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&orderType=${this.orderType}&orderBy=${this.orderBy}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
    this.getReviewUrlList();
  }

  getReviewUrlList() {
    this.apiservice
      .get(
        `admin/review/review-url/get-review-urls?page=${Number(this.pageIndex + 1)}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''
        }&orderBy=${this.orderBy}&orderType=${this.orderType}&searchBy=${this.searchBy}&searchType=${this.searchType}`
      )
      .subscribe((res: any) => {
        if (res.body) {
          if (res.body?.ReviewUrls.data) {
            this.itemList = res.body?.ReviewUrls.data;
            this.totalCount = res.body?.ReviewUrls.total;
            this.dataSource = new MatTableDataSource(this.itemList);
            this.cdr.detectChanges();
          } else {
            this.itemList = undefined;
          }
        }
      });
  }

  onFilterChange(value: string) {
    this.pageIndex = 0;
    this.searchedKeyword = value.trim();
    this.router.navigateByUrl(
      `/reputation/review-url?page=${this.pageIndex + 1
      }${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&orderType=${this.orderType}&orderBy=${this.orderBy}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
    this.getReviewUrlList();
  }

  deleteUrl(type: string, id: any): void {
    const obj = { width: '500px', data: { type, id } }
    const dialogref = this.dialog.open(PartnerActionComponent, obj);
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.apiservice.delete('admin/review/review-url/delete-review-url/' + id).subscribe((res:any)=>{
          if(res.body){
            this.apiservice.alert(res.body?.message, 'success');
            this.getReviewUrlList();
          }
        }, err =>{
          this.apiservice.alert('Please try again', 'error');
        });
      }
    });
  }
  navigatePage(data:any){
   this.router.navigate(['/reputation/edit-review-url', data?.id])
  };

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: FilterValue[] = [
    {title: 'Type', value: 'type'},
    {title: 'Percentage', value: 'percentage'},
    {title: 'Url', value: 'url'}
  ];
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/reputation/review-url?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}&orderType=${this.orderType}`);
    this.isShowFilter = false;
    this.getReviewUrlList();
  }


  ngOnDestroy() { }

}
